export enum CookWorkStatus {
  ONBOARDING_INCOMPLETE = "ONBOARDING_INCOMPLETE",
  FREE_TO_WORK = "FREE_TO_WORK",
  RE_TRAINING = "RE_TRAINING",
  NOT_FREE_TO_WORK = "NOT_FREE_TO_WORK",
  BLACKLISTED = "BLACKLISTED",
}
